import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { IAccount } from '../../store/models/account.model';
import { ISelectItem } from '../../store/models/select.model';
import { UtilitiesService } from '../../store/services/utilities.servive';

@Component({
  selector: 'app-add-blocked-date-rule',
  templateUrl: './add-blocked-date-rule.component.html',
  styleUrls: ['./add-blocked-date-rule.component.scss'],
})
export class AddBlockedDateRuleComponent implements OnInit {

  inputForm: FormGroup;

  managers: IAccount[];
  partners: IAccount[];

  componentReady = false;

  constructor(
    private readonly utilService: UtilitiesService,
  ) {
  }

  get block_types(): ISelectItem[] {
    return ['Cycle', 'FollowUp', 'Campaign'].map(i => ({
      label: i,
      value: i.toLowerCase(),
    }));
  }

  get timezones(): ISelectItem[] {
    return this.utilService.getTimezones('ALL').map(t => ({
      label: t,
      value: t,
    }));
  }

  get states(): ISelectItem[] {
    const states = this.utilService.getStates();
    const allStates = {
      ...states.CA,
      ...states.US,
      ...states.CI,
      ...states.UK,
      ...states.AU
    };

    return Object.keys(allStates).map(k => ({
      label: allStates[k],
      value: k,
    }));
  }

  get managersItems(): ISelectItem[] {
    return this.managers.map(m => ({
      label: `${m.first_name} ${m.last_name} (${m.email})`,
      value: m.account_id,
    }));
  }

  get partnersItems(): ISelectItem[] {
    return this.partners.map(p => ({
      label: `${p.first_name} ${p.last_name} (${p.email})`,
      value: p.account_id,
    }));
  }

  ngOnInit(): void {
    if (this.inputForm) {
      this.inputForm.addControl('block_type', new FormControl(''));
      this.inputForm.addControl('timezones', new FormControl(''));
      this.inputForm.addControl('states', new FormControl(''));
      this.inputForm.addControl('managers', new FormControl(''));
      this.inputForm.addControl('partners', new FormControl(''));

      this.componentReady = true;
    }
  }

}
